export const StatCards = ({ cards }) => {
    return (
        <div className="">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                {cards.map((card, i) => (
                    <div
                        key={i}
                        className={`${card.bg} border border-gray-200 rounded-2xl p-4 flex justify-between items-center shadow-xs`}
                    >
                        <div>
                            <div className="text-2xl font-bold">
                                {card.value}
                            </div>
                            <div className="text-sm text-gray-600">
                                {card.label}
                            </div>
                        </div>
                        <div
                            className={`text-3xl ${card.color} bg-white rounded-full p-2 shadow-inner`}
                        >
                            {card.icon}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
